import Column from '@components/column'
import { FC, useEffect, useState } from 'react'
import { Form, Formik } from 'formik'
import Fields from '@components/fields'
import Educations from './educations'
import Experiences from './experiences'
import Documents from '../documents'
import DoctorProfileDetails from './profileDetails'
interface ProfileDetailsProps {
  disabled?: boolean
  doctor: any
}
const PersonalDetails: FC<ProfileDetailsProps> = ({ doctor, disabled }) => {
  const initial = {
    name: '',
    email: '',
    phoneNo: '',
    countryCode: 977,
    address: '',
    departments: '',
    qualification: '',
    gender: '',
    yos: '',
    specializations: [],
    fees: 0,
    bio: '',
    appointmentType: '',
    age: '',
    educations: [],
    experiences: [],
    identifications: [
      {
        image: '',
        name: 'Citizenship',
        number: '',
      },
      {
        image: '',
        name: 'Passport',
        number: '',
      },
      {
        image: '',
        name: 'National Id',
        number: '',
      },
    ],
    licenses: [],
    signature: '',
  }
  const [initialValues, setInitialValues] = useState<any>(initial)
  const identifications = doctor?.documents?.filter(
    (document: any) => document?.type == 'Identification',
  )
  const licenses = doctor?.documents?.filter(
    (document: any) => document?.type == 'License',
  )
  const signature = doctor?.documents?.find(
    (document: any) => document?.type == 'Signature',
  )
  const citizenship = identifications?.findIndex(
    (document) => document?.infos?.name == 'Citizenship',
  )
  const passport = identifications?.findIndex(
    (document) => document?.infos?.name == 'Passport',
  )
  const nationalId = identifications?.findIndex(
    (document) => document?.infos?.name == 'National Id',
  )
  useEffect(() => {
    if (!!doctor?.id) {
      setInitialValues({
        name: doctor?.name,
        email: doctor?.email,
        phoneNo: doctor?.phoneNo,
        countryCode: doctor?.countryCode,
        address: doctor?.infos?.address,
        departments: doctor?.departments[0]?.id || '',
        qualification: doctor?.infos?.qualification,
        gender: doctor?.infos?.gender,
        yos: doctor?.infos?.yos,
        specializations: doctor?.specializations,
        fees: doctor?.infos?.fees,
        appointmentType: doctor?.infos?.appointmentType,
        age: doctor?.infos?.age,
        bio: doctor?.infos?.bio,
        educations: doctor?.educations,
        experiences: doctor?.experiences,
        signature: !!signature?.id ? signature?.infos?.image : null,
        licenses: licenses?.length
          ? licenses?.map((license: any) => {
              return {
                id: license?.id,
                name: license?.infos?.name,
                image: license?.infos?.image,
                oldPath: license?.infos?.image,
              }
            })
          : [],
        identifications:
          identifications?.length >= 3
            ? identifications
            : [
                !!identifications?.[citizenship]
                  ? {
                      ...identifications[citizenship]?.infos,
                      oldPath: identifications[citizenship]?.infos?.image,
                      id: identifications[citizenship]?.id,
                    }
                  : {
                      image: '',
                      name: 'Citizenship',
                      number: '',
                    },
                !!identifications?.[passport]
                  ? {
                      ...identifications[passport]?.infos,
                      oldPath: identifications[passport]?.infos?.image,
                      id: identifications[passport]?.id,
                    }
                  : {
                      image: '',
                      name: 'Passport',
                      number: '',
                    },
                !!identifications?.[nationalId]
                  ? {
                      ...identifications[nationalId]?.infos,
                      oldPath: identifications[nationalId]?.infos?.image,
                      id: identifications[nationalId]?.id,
                    }
                  : {
                      image: '',
                      name: 'National Id',
                      number: '',
                    },
              ],
      })
    } else {
      setInitialValues(initial)
    }
  }, [doctor?.id])
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={() => {}}
      enableReinitialize
    >
      {({ handleSubmit, setFieldValue, values, errors }) => {
        return (
          <Form onSubmit={handleSubmit}>
            <DoctorProfileDetails
              setFieldValue={setFieldValue}
              values={values}
              errors={errors}
              disabled={disabled}
            />
            <Column
              styleColumn="border-radius:8px;padding:20px;margin-top:20px;"
              bg="white"
            >
              <Fields.TextArea
                name="bio"
                label="Description"
                placeholder="Description"
                rows={5}
                disabled={disabled}
              />
            </Column>
            <Educations educations={values?.educations} />
            <Experiences experiences={values?.experiences} />
            <Documents
              identifications={values?.identifications}
              licenses={values?.licenses}
              setFieldValue={setFieldValue}
              disabled={disabled}
              role="doctor"
            />
          </Form>
        )
      }}
    </Formik>
  )
}

export default PersonalDetails
